import { createContext, useContext } from "react";
import type { PortalContext, Profile } from "./types";

/**
 * What every screen may read: the portal (from `/api/interactiveplayer/v1/portal/context`), the
 * signed-in member (or null), and navigation.
 */
export interface PortalState {
  context: PortalContext;
  /** The signed-in member; null = signed out. */
  me: Profile | null;
  setMe(me: Profile | null): void;
  /** Re-read `/me` (after a refresh or a profile change). */
  reloadMe(): Promise<Profile | null>;
  go(path: string): void;
  replace(path: string): void;
  /** "Tillbaka": the previous in-app page, or this page's parent. */
  back(): void;
  /** Prefill for the login form (after an invite or a reset). */
  loginEmail: string;
  setLoginEmail(email: string): void;
}

export const PortalStateContext = createContext<PortalState | null>(null);

export function usePortal(): PortalState {
  const s = useContext(PortalStateContext);
  if (!s) throw new Error("usePortal outside the portal shell");
  return s;
}

/** The provider's name as the app is called ("Watch in the X app"). */
export function appName(context: PortalContext): string {
  return context.skin.identity?.displayName?.trim() || context.portal.name;
}
